import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import useStyles from './style';
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import AILeaning from './index.js';
import Preview from '../../../../img/Graphic.png';
export default function AIpreview({
  open = false,
  handleOpen = () => {},
  handleClose = () => {},
  user,
}) {
  const classes = useStyles();

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.sessionPreview}>
          <Box className={classes.gradient}>
            {/* <Grid display={'flex'} justifyContent={'right'}>
              <CloseIcon onClick={handleClose} className={classes.close} />
            </Grid> */}
            <Grid container spacing={12} className={classes.Container}>
              <Grid item xs={4} lg={4} style={{ paddingLeft: '10px' }}>
                <img src={Preview} />
              </Grid>
              <Grid item xs={8} lg={8} style={{ paddingLeft: '10px' }}>
                <AILeaning onClick={handleClose} user={user} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
